module.exports = new __parcel__URL__("train_50_active.3f43d810.png").toString();